import ErrorBox from "../../../components/Error/Box";
import 'tippy.js/dist/tippy.css';
import { useQuery } from "@tanstack/react-query";
import ApplicationBodyItem from "@/routers/Channel/Application/ApplicationBody";

export default function AppHomeUserApplications() {

    const getApplications = useQuery({
        queryKey: ["applications"],
        queryFn: async () => {
            const response = await fetch("__SITE_BASE__/api/v1/me/applications"+"?withTeam="+"true");
            if (!response.ok) throw new Error("Failed to fetch applications data");
            return response.json();
        },
        retry: 1,
        retryDelay: 1000,
    });

    return (
        <>
            <div className="max-h-screen min-h-screen overflow-auto p-1 sm:p-4 sm:px-32" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}>
                
                <h1 className="text-gray-300 font-semibold text-2xl sm:mb-4">
                    My Applications
                </h1>
                <div className="pt-8">
                    <span className="text-white font-semibold text-lg">
                        {getApplications?.data?.applications?.length} Applications
                    </span>
                    <div className="bg-brand-dark rounded-lg mt-4 overflow-x-auto">
                        <table className="w-full text-left text-sm sm:text-base">
                            <thead>
                                <tr className="bg-brand-darker text-gray-400">
                                    <th className="py-3 px-4 whitespace-nowrap">Applicant</th>
                                    <th className="py-3 px-4 whitespace-nowrap">Status</th>
                                    <th className="py-3 px-4 whitespace-nowrap">Submitted At</th>
                                    <th className="py-3 px-4 whitespace-nowrap">Team</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getApplications.isLoading ? (
                                    [...Array(13)].map((_, index) => (
                                        <tr key={index} className="bg-brand-darker animate-pulse">
                                            <td className="py-3 px-4"></td>
                                            <td className="py-3 px-4"></td>
                                            <td className="py-3 px-4"></td>
                                            <td className="py-3 px-4"></td>
                                        </tr>
                                    ))
                                ) : getApplications.isError || getApplications.data?.message ? (
                                    <ErrorBox message={(getApplications.error || getApplications.data?.message)?.toString()} />
                                ) : (
                                    getApplications?.data?.applications?.map((application: any, index: number) => (
                                        <ApplicationBodyItem item={application} me={null} key={index} isMeApplications={true} />
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}
